export default __webpack_public_path__ + "static/media/rectangles-no-7.da7871b3.mid";